import { Col, Row } from 'antd';
import { Optional } from '../Shared';

export type SimpleTableRow = {
  /**
   * Title of the row (the first column)
   *
   * If this is undefined, the entire row will be consumed by the row `content`.
   */
  readonly title?: JSX.Element | string;
  /**
   * Content of the row (the second column)
   */
  readonly content?: JSX.Element | string;
  /**
   * The condition that must be met to show the row
   *
   * @default true
   */
  readonly condition?: boolean;
};

/**
 * A simple table with two columns
 */
export const SimpleTable: React.FC<{
  /**
   * The table's contents
   */
  readonly rows: readonly SimpleTableRow[];
  /**
   * The width of the first column
   */
  readonly firstColumnWidth: number | string;
}> = ({ rows, firstColumnWidth }) => (
  <div style={{ display: 'block' }}>
    <div
      className="simple-table"
      style={{ overflow: 'auto', paddingRight: 10 }}
    >
      {rows.map(({ title, content, condition = true }, i) => (
        <Optional show={condition} key={i}>
          <Row
            className="simple-table-row"
            style={{ paddingBottom: 10 }}
            wrap={false}
          >
            <Optional show={title !== undefined}>
              <Col className="simple-table-title" flex={firstColumnWidth}>
                {title}
              </Col>
            </Optional>
            <Optional show={content !== undefined}>
              <Col className="simple-table-content" flex={'auto'}>
                {content}
              </Col>
            </Optional>
          </Row>
        </Optional>
      ))}
    </div>
  </div>
);
